import React from 'react';
import Script from 'next/script';

export const SCHEMA_ORG = 'https://schema.org/';
export const MEC_URL = 'https://www.mec.ca/';

export const StructuredArticleData = ({ data }: any) => {
  let pageUrl = '';
  if (typeof window !== 'undefined') {
    pageUrl = window?.location?.href;
  }
  const jsonLd = {
    '@context': SCHEMA_ORG,
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
      url: pageUrl,
    },
    headline: data?.title,
    image: [data?.hero_image?.url],
    datePublished: data?.first_publication_date,
    dateModified: data?.last_publication_date,
    publisher: {
      '@type': 'Organization',
      name: 'MEC',
    },
  };

  return (
    <Script id="article-structured-search-data" type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </Script>
  );
};
